import React                  from 'react';
import { Observe }            from 'rewire-core';
import { withStyles }         from 'rewire-ui';
import Typography             from '@material-ui/core/Typography';
import { Theme, makeStyles }  from '@material-ui/core/styles';
import CheckIcon              from '@material-ui/icons/Check';
import { Group as GroupIcon } from 'mdi-material-ui';
import OptionsToggleMenu, {
  OptionsToggleMenuProps,
}                             from './OptionsToggleMenu';
import PriorityGroupMenuModel from './PriorityGroupMenuModel';
import { isNullOrUndefined }  from 'rewire-common';

const groupingItemIconStyles = (_theme: Theme) => ({
  priorityText: {
    paddingLeft: '2px',
  }
});

const useGroupingItemIconStyles = makeStyles(groupingItemIconStyles);

export const getGroupingItemIcon = (model: PriorityGroupMenuModel, group: string) => (): JSX.Element | null => {
  const classes = useGroupingItemIconStyles();

  return <Observe render={() => {
    const isSingle = model.isSingleSelectMode;
    const priority = model.getGroupPriority(group);
    return !isNullOrUndefined(priority)
      ? <><CheckIcon /><Typography className={classes.priorityText}>{!isSingle ? priority : ''}</Typography></>
      : null;
  }} />;
};

const styles = (theme: Theme) => ({
  menuButton: {
  },
  menu: {
  },
  menuTitleContainer: {
  },
  listItemText: {
  },
  listItemTypography: {
  },
  listItemIcon: {
  },
  menuItem: {
  },
  menuItemSelected: {
  },
  menuItemDisabled: {
  },
  hasSelection: {
    color: theme.palette.secondary.main
  },
});

interface IPriorityGroupMenuProps {
  model: PriorityGroupMenuModel;
}

export type PriorityGroupMenuProps = IPriorityGroupMenuProps & Omit<OptionsToggleMenuProps & {classes?: {hasSelection: any;}} , 'title' | 'tooltip' | 'items'>;

class PriorityGroupMenu extends React.Component<PriorityGroupMenuProps> {
  constructor(props: PriorityGroupMenuProps) {
    super(props);
  }

  render() {
    const { model, classes, ...restProps } = this.props;
    const { hasSelection, ...restClasses } = classes;

    return <Observe render={() => {
      const groupTooltip   = model.getGroupTooltip();
      const groupMenuItems = model.getGroupMenuItems();

      return (groupMenuItems && groupMenuItems.length > 0)
        ? <OptionsToggleMenu
            title={model.title}
            tooltip={groupTooltip}
            buttonContent={<Observe render={() => <GroupIcon className={model.hasGroups ? hasSelection : ''} /> } />}
            items={groupMenuItems}
            onItemClick={model.handleItemClick}
            classes={restClasses}
            {...restProps as any}
          />
        : null;
    }} />;
  }
}

export default withStyles<Omit<PriorityGroupMenuProps, 'classes'>, any>(styles, PriorityGroupMenu);
